import { createStore } from "vuex";
import { getToken, removeToken, removeUserInfo, setUserInfo } from "@/utils/auth";
import { getUserInfo } from "@/apis/user";

const store = createStore({
  state: {
    theme: true,
    isLogin: getToken() ? true : false,
    userInfo: localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo") || "")
      : null,
    biList: [],
    selectedBi: null,
    showLiveChat: true, // 初始值为 true，显示livechat聊天窗口

  },
  mutations: {
    changeTheme(state) {
      if (state.theme) {
        state.theme = false;
      } else {
        state.theme = true;
      }
    },
    setIsLogin(state, isLogin) {
      state.isLogin = isLogin;
      if (!isLogin) {
        removeToken();
      }
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      if (!userInfo) {
        removeUserInfo();
      } else {
        setUserInfo(userInfo);
      }
    },
    setBiList(state, biList) {
      state.biList = biList;
    },
    setSelectedBi(state, selectedBi) {
      state.selectedBi = selectedBi;
    },
    setShowLiveChat(state, value) {
      state.showLiveChat = value;
    },
  },
  actions: {
    clearLoginData({ commit }) {
      commit("setIsLogin", false);
      commit("setUserInfo", null);
    },
    updateShowLiveChat({ commit }, value) {
      commit('setShowLiveChat', value);
    },
    async getUserInfo({ commit }) {
      await getUserInfo().then((res: any) => {
        commit("setUserInfo", res.data);
      });
    },
  },
});

export default store;
